import React from 'react';

import RepoList from './RepoList';

import './Projects.css';

export function Projects () {

    return (
        <div id="projects" className="section">
            <RepoList />
        </div>
    );
}